// src/redux/slices/organizerSettingsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// ✅ Async thunk to fetch organizer settings
export const fetchOrganizerSettings = createAsyncThunk(
  "organizerSettings/fetch",
  async (slug, { rejectWithValue }) => {
    try {
      const Url = `${process.env.REACT_APP_BASE_URL}/api/user/settings/${slug}`;

      const res = await axios.get(Url, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_API_KEY}`,
          Accept: "application/json",
        },
      });

      if (res.data.success) {
        return res.data.data;
      } else {
        return rejectWithValue("Failed to load settings");
      }
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const organizerSettingsSlice = createSlice({
  name: "organizerSettings",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearOrganizerSettings: (state) => {
      state.data = null;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrganizerSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrganizerSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchOrganizerSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearOrganizerSettings } = organizerSettingsSlice.actions;
export default organizerSettingsSlice.reducer;
